import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      e1: true,
      e2: true,
      isLoading: false,
      dialog: false,
      password: '',
      confirmPassword: '',
      currentPassword: ''
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    },
    isValid () {
      return this.password !== '' && this.confirmPassword !== '' && this.currentPassword !== ''
    }
  },
  mounted () {
    this.dialog = true
  },
  methods: {
    ...mapActions([
      'actionEditUser',
      'actionChangePassword'

    ]),
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    changePassword () {
      if (this.password === this.confirmPassword) {
        const user = {
          name: this.getterAccount.userName,
          email: this.email,
          password: this.password,
          currentPassword: this.currentPassword,
          idUserType: this.getterAccount.idUserType,
          idUser: this.getterAccount.idUser,
          idClient: this.getterAccount.idClient,
          idUserLogged: this.getterAccount.idUser
        }

        this.isLoading = true

        this.actionChangePassword(user)
          .then(() => {
            this.sendToast({
              text: 'Senha alterada com sucesso',
              type: 'success'
            })

            this.closeModal()
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Não foi possível atualizar a senha',
              type: 'danger'
            })
          })
      } else {
        this.sendToast({
          text: 'Suas senhas não são iguais, verifique',
          type: 'warning'
        })

        this.isLoading = false
      }
    }
  }
}
